import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export interface Testimonial {
  name: string;
  location: string;
  quote: string;
  rating?: number;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
}
export function Testimonials({
  testimonials,
  title
}: TestimonialsProps) {
  return <section className="py-16 md:py-24 px-4" data-id="element-258">
      <div className="max-w-6xl mx-auto" data-id="element-259">
        {title && <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-heading font-bold text-center mb-16 text-white" data-id="element-260">
            {title}
          </motion.h2>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-261">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-dark-card border border-dark-border p-8 rounded-xl flex flex-col h-full relative overflow-hidden group hover:border-gold/30 transition-colors" data-id="element-262">
              {/* Subtle top gradient */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-263" />

              <div className="flex gap-1 mb-6" data-id="element-264">
                {[...Array(t.rating || 5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-265" />)}
              </div>

              <blockquote className="flex-grow text-gray-300 italic mb-8 leading-relaxed" data-id="element-266">
                "{t.quote}"
              </blockquote>

              <div className="mt-auto pt-6 border-t border-dark-border/50" data-id="element-267">
                <div className="font-bold text-white" data-id="element-268">{t.name}</div>
                <div className="text-sm text-gold-light" data-id="element-269">— {t.location}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}